import React from 'react'
import { PageContainerToolbar } from '@toolpad/core/PageContainer'
import Box from '@mui/material/Box';
import { useDispatch, useSelector } from 'react-redux';
import Typography from '@mui/material/Typography';
import { setProfileModalOpen } from '../../../store/profile/profileSlice';
import { setAction } from '../../../store/profile/profileSlice'; 

const ProfilePageToolbar = () => {
  const dispatch = useDispatch();

  const { 
    is_profile_modal_open,
  } = useSelector((state) => state.profile);

  const handleProfileModal = (c_action) => {
    dispatch(setProfileModalOpen(!is_profile_modal_open))
    dispatch(setAction(c_action))
  };  
  
  return (
      <PageContainerToolbar sx={{display:'flex', justifyContent : 'space-between', marginLeft: 0, width: '80vw', flexDirection : {lg:'row', md:'column', xs:'column'} }}>
        
        {/* ✅ Breadcrumb Section */}
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography 
            variant="body1" 
            sx={{ color: '#0009', cursor: 'pointer', fontWeight: 500 }}
            onClick={() => window.location.replace('/admin')}
          >
            Dashboard
          </Typography>
          <Typography 
            variant="body1" 
            sx={{ mx: 1, fontWeight: 500, color: 'text.secondary', userSelect: 'none' }}
          >
            /
          </Typography>
          <Typography variant="body1" sx={{ color: 'text.primary', fontWeight: 500 }}>
            Profile
          </Typography>
        </Box>

      </PageContainerToolbar>
  )
}

export default ProfilePageToolbar
